import corporateTransportationSubmissions from "./corporateTransportationSubmissions.component";
import corporateTransportationSubmissionsUrls from "./corporateTransportationSubmissions.urls";
import CorporateTransportationSubmissionsTransforms from "./corporateTransportationSubmissions.transforms";

const corporateTransportationSubmissionsModule = angular
  .module("app.components.corporateTransportationSubmissions", [])
  .component(
    "corporateTransportationSubmissionsPage",
    corporateTransportationSubmissions
  )
  .service(
    "CorporateTransportationSubmissionsTransforms",
    CorporateTransportationSubmissionsTransforms
  )
  .config(corporateTransportationSubmissionsUrls);

export default corporateTransportationSubmissionsModule;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmissions/corporateTransportationSubmissions.module.js